import {
  useTaskBonusTotals,
  getTaskBonusPeriod,
} from "../../../hooks/useTaskBonusTotals.js";
import { addRankingPoints } from "../../../hooks/useTaskBonusTotals.js";
import { DefaultAvatar } from "../../../components/ProfileSummary/index.jsx";
import React, { useState, useMemo, useEffect } from "react";
import "./ranking.css";
import { iniMes, iniSemana, todayISO, fmtNum } from "../../../shared/utils";
import { sourceImage } from "../../../utils/source-image";
const filtrarPorPeriodo = (lista, periodo) => {
  const hoje = todayISO();
  const sem = iniSemana();
  const mes = iniMes();
  const ano = new Date(Date.now() - 365 * 86400000).toISOString().slice(0, 10);
  return lista.filter((item) => {
    if (item.status_questao === "invalido") return false;
    if (periodo === "hoje") return item.data_estudo === hoje;
    if (periodo === "semana") return item.data_estudo >= sem;
    if (periodo === "mes") return item.data_estudo >= mes;
    if (periodo === "ano") return item.data_estudo >= ano;
    return true;
  });
};
export default function Rankings(props) {
  const institutionContext = props.institutionContext;
  let checkpoints = props.checkpoints;
  let checkpointsComAutomaticos = props.checkpointsComAutomaticos;
  let students = props.students;
  let houses = props.houses;
  let teachers = props.teachers;
  let activities = props.activities;
  let agendamentos = props.agendamentos;
  let verPerfil = props.verPerfil;
  const [escopo, setEscopo] = useState("individual");
  const [tipoId, setTipoId] = useState(0);
  const [periodo, setPeriodo] = useState("semana");
  const [casaId, setCasaId] = useState(0);
  const [profId, setProfId] = useState(0);
  const checkpointsBase = useMemo(() => Array.isArray(checkpoints) ? checkpoints : [], [checkpoints]);
  const checkpointsAutomaticosBase = Array.isArray(checkpointsComAutomaticos)
    ? checkpointsComAutomaticos
    : checkpointsBase;
  const baseRankingBonus = useTaskBonusTotals(
    !institutionContext,
    null,
    getTaskBonusPeriod(periodo).from,
    getTaskBonusPeriod(periodo).to,
    props.showFlash,
    true,
  );
  const rankingBonus = institutionContext
    ? props.rankingBonus
    : baseRankingBonus;
  const activityPeriod = getTaskBonusPeriod(periodo);
  const activityPeriodMatches = !institutionContext || (
    (rankingBonus.period?.from || null) === (activityPeriod.from || null) &&
    rankingBonus.period?.to === (activityPeriod.to || todayISO())
  );
  const cpsTempo = useMemo(
    () => filtrarPorPeriodo(checkpointsBase, periodo),
    [checkpointsBase, periodo],
  );
  const cpsTempoComAutomaticos = useMemo(
    () => filtrarPorPeriodo(checkpointsAutomaticosBase, periodo),
    [checkpointsAutomaticosBase, periodo],
  );
  const ranking = useMemo(() => {
    if ("individual" === escopo) {
      const mapValue = {};
      students
        .filter((student) => student.ativo)
        .forEach((item) => {
          if (
            !(
              (casaId && Number(item.casa_id) !== Number(casaId)) ||
              (profId && Number(item.professor_id) !== Number(profId))
            )
          ) {
            mapValue[Number(item.id)] = {
              aluno: item,
              valor: 0,

            };
          }
        });
      cpsTempo.forEach((cpsTempoAluno_id) => {
        const alunoId = Number(cpsTempoAluno_id.aluno_id);
        if (!mapValue[alunoId]) return;
        (Array.isArray(cpsTempoAluno_id.itens)
          ? cpsTempoAluno_id.itens
          : []
        ).forEach((item) => {
          if (
            activities.find(
              (activity) => Number(activity.id) === Number(item.tipo_id),
            )
          ) {
            if (0 !== tipoId && Number(item.tipo_id) === Number(tipoId)) {
              mapValue[alunoId].valor += Number(item.quantidade || 0);
            }

          }
        });
      });
      if (0 === tipoId) {
        cpsTempoComAutomaticos.forEach((cpsTempoComAutomatico) => {
          const alunoId = Number(cpsTempoComAutomatico.aluno_id);
          if (mapValue[alunoId]) {
            mapValue[alunoId].valor = addRankingPoints(
              mapValue[alunoId].valor,
              Number(cpsTempoComAutomatico.pontos_rank || 0),
            );
          }
        });
      }
      if (0 === tipoId)
        Object.entries(rankingBonus.points).forEach(([sid, points]) => {
          if (mapValue[Number(sid)])
            mapValue[Number(sid)].valor = addRankingPoints(
              mapValue[Number(sid)].valor,
              points,
            );
        });
      const mesAtual = new Date().toISOString().slice(0, 7);
      students
        .filter((student) => student.ativo)
        .forEach((item) => {
          if (casaId && Number(item.casa_id) !== Number(casaId)) return;
          if (profId && Number(item.professor_id) !== Number(profId)) return;
          const alunoId = Number(item.id);
          if (mapValue[alunoId]) {
            mapValue[alunoId].agMes = (agendamentos || []).filter(
              (itemAluno_id) =>
                Number(itemAluno_id.aluno_id) === alunoId &&
                "confirmado" === itemAluno_id.status &&
                itemAluno_id.data.startsWith(mesAtual),
            ).length;
            mapValue[alunoId].convidadosMes = (agendamentos || []).filter(
              (itemAluno_id) =>
                Number(itemAluno_id.aluno_id) === alunoId &&
                "confirmado" === itemAluno_id.status &&
                itemAluno_id.data.startsWith(mesAtual) &&
                itemAluno_id.convidado,
            ).length;
          }
        });
      return Object.values(mapValue)
        .filter((item) => 0 === tipoId || item.valor > 0)
        .sort(
          (left, right) =>
            right.valor - left.valor ||
            left.aluno.nome.localeCompare(right.aluno.nome),
        );
    }
    const map = {};
    houses.forEach((house) => {
      map[Number(house.id)] = {
        casa: house,
        valor: 0,
        alunos: students.filter(
          (student) =>
            student.ativo && Number(student.casa_id) === Number(house.id),
        ).length,
      };
    });
    if (0 === tipoId) {
      cpsTempoComAutomaticos.forEach((cpsTempoComAutomatico) => {
        const student = students.find(
          (studentId) =>
            Number(studentId.id) === Number(cpsTempoComAutomatico.aluno_id),
        );
        const casaAlunoId = Number(student?.casa_id);
        if (student && casaAlunoId && map[casaAlunoId]) {
          map[casaAlunoId].valor = addRankingPoints(
            map[casaAlunoId].valor,
            Number(cpsTempoComAutomatico.pontos_rank || 0),
          );
        }
      });
    } else {
      cpsTempo.forEach((cpsTempoAluno_id) => {
        const student = students.find(
          (studentId) =>
            Number(studentId.id) === Number(cpsTempoAluno_id.aluno_id),
        );
        const casaAlunoId = Number(student?.casa_id);
        if (student && casaAlunoId && map[casaAlunoId]) {
          (Array.isArray(cpsTempoAluno_id.itens) ? cpsTempoAluno_id.itens : [])
            .filter((item) => Number(item.tipo_id) === Number(tipoId))
            .forEach((item) => {
              map[casaAlunoId].valor += Number(item.quantidade || 0);
            });
        }
      });
    }
    if (0 === tipoId) {
      Object.entries(rankingBonus.points).forEach(([sid, points]) => {
        const student = students.find((row) => Number(row.id) === Number(sid));
        const house = Number(student?.casa_id);
        if (student && house && map[house])
          map[house].valor = addRankingPoints(map[house].valor, points);
      });
    }
    return Object.values(map).sort((left, right) => right.valor - left.valor);
  }, [
    escopo,
    students,
    houses,
    cpsTempo,
    cpsTempoComAutomaticos,
    tipoId,
    casaId,
    profId,
    activities,
    agendamentos,
    rankingBonus.points,
  ]);
  const tipo = activities.find(
    (activity) => Number(activity.id) === Number(tipoId),
  );
  const unid = 0 === tipoId ? "pontos" : tipo ? tipo.unidade + "s" : "";
  const perLabel = {
    hoje: "Hoje",
    semana: "Semana",
    mes: "Mes",
    ano: "Ano",
    tudo: "Total",
  }[periodo];
  useEffect(() => {
    institutionContext?.onRange?.(periodo);
  }, [periodo, institutionContext]);
  return (
    <div className={"ct"}>
      <h1 className={"pt"}>
        <em>{"Rankings"}</em>
        {institutionContext
          ? " - " + (houses[0]?.nome || "Instituição")
          : " - Mundial"}
      </h1>
      <div className={"ps"}>
        {perLabel}
        {" - "}
        {0 === tipoId ? "Pontos de Ranking" : tipo?.nome}
      </div>
      <div className={"tabs"}>
        <button
          className={"individual" === escopo ? "a" : ""}
          onClick={() => setEscopo("individual")}
        >
          {"Individual"}
        </button>
        <button
          className={"casa" === escopo ? "a" : ""}
          onClick={() => setEscopo("casa")}
        >
          {"Por instituição"}
        </button>
      </div>
      <div className={"fi"}>
        <span className={"fl"}>{"Atividade"}</span>
        <select
          className={"sel"}
          value={tipoId}
          onChange={(event) => setTipoId(Number(event.target.value))}
        >
          <option value={0}>{"Pontos do ranking"}</option>
          {activities
            .filter((activity) => activity.ativo)
            .map((item) => (
              <option value={item.id} key={item.id}>
                {item.nome}
              </option>
            ))}
        </select>
        <span className={"fl"}>{"Período"}</span>
        <select
          className={"sel"}
          value={periodo}
          onChange={(event) => setPeriodo(event.target.value)}
        >
          <option value={"hoje"}>{"Hoje"}</option>
          <option value={"semana"}>{"Semana"}</option>
          <option value={"mes"}>{"Mes"}</option>
          <option value={"ano"}>{"Ano"}</option>
          <option value={"tudo"}>{"Total"}</option>
        </select>
        {"individual" === escopo && (
          <React.Fragment>
            <select
              className={"sel"}
              value={casaId}
              onChange={(event) => setCasaId(Number(event.target.value))}
            >
              <option value={0}>{"Todas as instituições"}</option>
              {houses.map((house) => (
                <option value={house.id} key={house.id}>
                  {house.nome}
                </option>
              ))}
            </select>
            <select
              className={"sel"}
              value={profId}
              onChange={(event) => setProfId(Number(event.target.value))}
            >
              <option value={0}>{"Todos os professores"}</option>
              {teachers
                .filter((teacher) => teacher.ativo)
                .map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.nome}
                  </option>
                ))}
            </select>
          </React.Fragment>
        )}
        <button
          className={"btn bg bs"}
          onClick={() => {
            setTipoId(0);
            setCasaId(0);
            setProfId(0);
            setPeriodo("semana");
          }}
        >
          {"Limpar filtros"}
        </button>
      </div>
      {0 === ranking.length ? (
        <div className={"es"}>
          <h3>{"Sem dados"}</h3>
          <p>{"Nenhum registro para esses filtros."}</p>
        </div>
      ) : "casa" === escopo ? (
        <div className={"cr"}>
          {ranking.map((rankingCasa, index) => (
            <div
              className={"cc ".concat(0 === index ? "t1" : "")}
              style={{
                borderColor: rankingCasa.casa.cor,
              }}
              key={rankingCasa.casa.id}
            >
              {rankingCasa.casa.imagem && (
                <img
                  src={sourceImage(rankingCasa.casa.imagem)}
                  className={"cc-img"}
                  alt={""}
                />
              )}
              <div className={"cp"}>{index + 1}</div>
              {null}
              <div className={"cnm"}>{rankingCasa.casa.nome}</div>
              <div className={"cv"}>{fmtNum(rankingCasa.valor, 2)}</div>
              <div className={"cmt"}>
                {unid}
                {" - "}
                {rankingCasa.alunos}
                {" alunos"}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={"rl ranking-list"}>
          {ranking.map((rankingAluno, index) => {
            const pos = index + 1;
            const top =
              1 === pos ? "t1" : 2 === pos ? "t2" : 3 === pos ? "t3" : "";
            const casa = houses.find(
              (house) =>
                Number(house.id) === Number(rankingAluno.aluno.casa_id),
            );
            return (
              <div
                className={"ri ".concat(top)}
                onClick={() => verPerfil(rankingAluno.aluno.id)}
                key={rankingAluno.aluno.id}
              >
                <div className={"rp"}>{pos}</div>
                <div
                  className={"rav"}
                  style={
                    rankingAluno.aluno.foto
                      ? {
                          backgroundImage: "url(".concat(
                            sourceImage(rankingAluno.aluno.foto),
                            ")",
                          ),
                        }
                      : {}
                  }
                >
                  {!rankingAluno.aluno.foto && DefaultAvatar()}
                </div>
                <div className={"rin"}>
                  <div className={"nm"} title={rankingAluno.aluno.nome}>{rankingAluno.aluno.nome}</div>
                  <div className={"mt ranking-institution"} title={[casa?.nome, rankingAluno.aluno.ano].filter(Boolean).join(" · ")}>
                    {casa && (
                      <span
                        style={{
                          color: casa.cor,
                          fontWeight: 700,
                        }}
                      >
                        {casa.nome}
                      </span>
                    )}
                    {rankingAluno.aluno.ano && (
                      <span>
                        {" - "}
                        {rankingAluno.aluno.ano}
                      </span>
                    )}

                  </div>
                  <div className={"mt ranking-study"} aria-live="polite">
                    {activityPeriodMatches && rankingBonus.activityTotals?.[rankingAluno.aluno.id] ? (
                      <RankingStudySummary totals={rankingBonus.activityTotals[rankingAluno.aluno.id]} />
                    ) : rankingBonus.error ? "Resumo de estudo indisponível" : rankingBonus.loading || !activityPeriodMatches ? "Atualizando estudo…" : "Resumo não disponível neste acesso"}
                    <span className="ranking-extra">{(rankingAluno.agMes || 0) > 0 && ` · ${rankingAluno.agMes} agendamentos`}</span>
                    <span className="ranking-extra">{(rankingAluno.convidadosMes || 0) > 0 && ` · ${rankingAluno.convidadosMes} convidados`}</span>
                  </div>
                </div>
                <div className={"rv"}>
                  {fmtNum(rankingAluno.valor, 2)}
                  <small>{unid}</small>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <p
        style={{
          marginTop: 12,
          fontSize: 11,
          color: "rgba(255,255,255,0.5)",
          textAlign: "center",
        }}
      >
        {"Clique em um aluno para ver o perfil completo."}
      </p>
    </div>
  );
}
export { Rankings };

// Totais do período escolhido. Não usar pontos como quantidade de respostas.
export function RankingStudySummary({ totals }) {
  const seconds = Number(totals.study_seconds);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const duration = hours > 0 ? `${hours} ${hours === 1 ? "hora" : "horas"} e ${minutes} ${minutes === 1 ? "minuto" : "minutos"} de estudo`
    : seconds > 0 && minutes === 0 ? "Menos de 1 minuto de estudo"
    : `${minutes} minutos de estudo`;
  const compactDuration = hours > 0 ? `${hours}h${String(minutes).padStart(2, "0")}`
    : seconds > 0 && minutes === 0 ? "<1min" : `${minutes}min`;
  return (
    <span>
      <span className="ranking-study-full">{duration} · {fmtNum(totals.open)} questões abertas · {fmtNum(totals.closed)} questões fechadas · {fmtNum(totals.flashcards)} flashcards</span>
      <span className="ranking-study-compact" aria-label={`${duration} · ${fmtNum(totals.open)} questões abertas · ${fmtNum(totals.closed)} questões fechadas · ${fmtNum(totals.flashcards)} flashcards`}>
        <span>{compactDuration}</span>
        <span>{fmtNum(totals.open)} {Number(totals.open) === 1 ? "aberta" : "abertas"}</span>
        <span>{fmtNum(totals.closed)} {Number(totals.closed) === 1 ? "fechada" : "fechadas"}</span>
        <span>{fmtNum(totals.flashcards)} flashcards</span>
      </span>
    </span>
  );
}
